<template>
    <div class="well-being">
        <Navbar :state="state" :subject="subject" >
<!--            <template v-slot:navMsg>-->
<!--                <TempAvailabilityMessage />-->
<!--            </template>-->
        </Navbar>

        <section class="bg-light product-section" :style="{backgroundImage: 'url(' + backgroundImage + ')'}">
            <div class="py-4" :class="{'overlay': backgroundImage}">
                <div class="container">
                    <Product
                        :product="product"
                        :publications="wellBeingPublications"
                        :state="state"
                        :grade="grade"
                        :subject="subject"
                        :language="language"
                    />
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <div class="col-8">
                                <h1 class="ml-0">
                                    Engage ALL <span class="text-purple">PreK-6</span><br/>
                                    students in <br/>
                                    <span class="text-purple">WELL-BEING</span>
                                </h1>
                            </div>
                            <div class="col-5"></div>
                        </div>
                        <div class="row">
                            <div class="col-12" style="font-size: 16px; line-height: 28px;">
                                Introducing a <strong class="text-purple">NEW CASEL-Aligned, Tier 1, 2, 3 Well-being curriculum</strong> to help you teach and support social-emotional learning and discussion in the classroom or remote.<br/><br/>
                                All within our student-friendly periodical format and robust online learning platform.
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <carousel :perPage="1" :autoplay="true">
                            <slide><img class="w-100" src="//cdn.studiesweekly.com/store/pages/wellbeing/1.png"></slide>
                            <slide><img class="w-100" src="//cdn.studiesweekly.com/store/pages/wellbeing/2.png"></slide>
                            <slide><img class="w-100" src="//cdn.studiesweekly.com/store/pages/wellbeing/3.png"></slide>
                        </carousel>

                    </div>
                </div>
            </div>
        </section>

        <BlockListViewer :blocks="stateData.wb_blocks" :publications="wellBeingPublications"/>

        <!-- <svg class="curve-down" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M0 0 C 50 100 80 100 100 0 Z"></path>
        </svg> -->

        <Footer />
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";
.box-images .expandable-image {
    box-shadow: 10px 5px 15px 0px black;
}
section {
    padding-bottom: 15px;
    padding-top: 15px;
}
section:nth-child(even) {
    background-color: #f8f9fa;
}
.text-purple {
    color: #6652a7;
}

.product-section {
    background-size: cover;
    background-repeat: no-repeat;
}

.product-section .overlay {
    height: 100%;
    background-color: rgba(0, 0, 0, .33);
}

.curve-down path {
    fill: $light;
    stroke: $light;
}

.thb-divider-container {
    position: absolute;
    top: auto;
    bottom: -1px;
    left: -1px;
    width: calc(100% + 2px);
    transform: translateZ(0);
    pointer-events: none;
}

.thb-svg-divider {
    fill: #f8f9fa;
}

.thb-divider-container .thb-svg-divider {
    width: 100%;
    left: 0;
    bottom: -1px;
    height: 100%;
    position: absolute;
}

.thb-divider-container.waves_opacity .thb-svg-divider path:nth-child(2) {
    fill-opacity: 0.15;
}

.thb-divider-container.waves_opacity .thb-svg-divider path:nth-child(3) {
    fill-opacity: 0.3;
}
</style>

<script>
import { mapState } from 'vuex'

import states from '@/common/states'

import Navbar from '@/components/Navbar'
import Product from '@/components/Product'
import Footer from '@/components/Footer'
import {Carousel, Slide} from 'vue-carousel'

import TempAvailabilityMessage from "@/components/TempAvailabilityMessage";
import BlockListViewer from "@/components/blocks/BlockListViewer";
import ExpandableImage from "@/components/ExpandableImage";

export default {
    name: 'social-studies',
    data: () => ({
        states: states,
        book: 1
    }),
    props: ['state', 'grade', 'subject', 'language'],
    computed:mapState({
        stateData: state => state.stateData.stateData,
        selectedState: state => state.stateData.selectedState,
        publicationResources: state => state.stateData.publicationResources,
        wellBeingPublications () {
            var wellBeingPublications = []

            _.forEach(this.stateData.publications, publication => {
                if(
                    (publication.topic == 'Well Being' || publication.topic == 'Well-Being') &&
                    publication.language == this.language
                ) {
                    wellBeingPublications.push(publication)
                }
            })

            wellBeingPublications = _.orderBy(wellBeingPublications, 'grade')
            wellBeingPublications = _.uniqBy(wellBeingPublications, 'grade')

            // console.log(wellBeingPublications)

            return wellBeingPublications
        },
        product () {
            let product = {}

            _.filter(this.wellBeingPublications, publication => {
                if (
                    publication.grade    == this.$route.params.grade &&
                    publication.language == this.$route.params.language &&
                    !publication.sample_of_id
                ) {
                    product = publication
                }
            })

            if (
                product.sku &&
                !this.publicationResources[product.sku]
            ) {
                this.getPublicationResources()
            }

            return product
        },
        backgroundImage () {
            var backgroundImage = null
            if (this.stateData.product_bg) {
                if (
                    this.stateData.product_bg.startsWith('http://') ||
                    this.stateData.product_bg.startsWith('https://') ||
                    this.stateData.product_bg.startsWith('//')
                ) {
                    backgroundImage = this.stateData.product_bg
                } else {
                    backgroundImage = '//' + this.stateData.product_bg
                }
            }
            return backgroundImage
        }
    }),
    watch: {
        '$route': {
            handler (route) {
                if (!route.params.state) {
                    this.$router.push({
                        name: 'well-being',
                        params: {
                            state: this.selectedState,
                            grade: 0,
                            subject: 'well-being',
                            language: 'en'
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    components: {
        ExpandableImage,
        BlockListViewer,
        TempAvailabilityMessage,
        Navbar,
        Product,
        Footer,
        Carousel,
        Slide
    },
    methods: {
        getPublicationResources () {
            this.$store.dispatch('getPublicationResources')
        },
        formattedState (value) {
            var formattedState = null
            _.forEach(this.states, state => {
                if (value == state.state) {
                    formattedState = state.fullState
                }
            })
            return formattedState
        },
        formattedSubject (subject) {
            var subject = subject.replace(/-/g, " ")
            return subject
        },
        switchFlippingBook (thisbook) {
            this.book = thisbook
        }
    }
}
</script>
